import type { Reducer } from "redux";
import type { State } from "..";
import actions from "~/shared/actions";
import type { Action } from "~/utils/actions";

function withInit(reducer: Reducer) {
	return (state: State | undefined, action: Action) => {
		switch (action.type) {
			case actions.INIT_STORE:
				return action.data;
			default:
				return reducer(state, action);
		}
	};
}
export default withInit;
